IREP.FSRegister = (function (){

    var init = function(){
        $("#manager").on("click", function () {
            $("#manager").addClass("completeCheck");
            $("#authorized").removeClass("completeCheck");
            $("#managerInfo").slideUp(250);
            $("#managerSubmit").fadeIn(250);
        });
        $("#authorized").on("click", function () {
            $("#authorized").addClass("completeCheck");
            $("#manager").removeClass("completeCheck");
            $("#managerInfo").slideDown(250);
            $("#managerSubmit").fadeIn(250);
        });
        $("#managerSubmit").on("click", function () { submitManager();});
    };

    var submitManager = function () {
        if ($("#managerInfo").is(":visible")) {
            if ($("#managerName").val().length > 0) {
                $("#managerName").removeClass("error");
                if ($("#managerEmail").val().length > 0) {
                    $("#managerEmail").removeClass("error");
                    var params = { isManager: false, managerName: $("#managerName").val(), managerEmail: $("#managerEmail").val() };
                    IREP.callApi("fivestar/managerinfo", "POST", params).done(function () {
                    });
                    showTY();
                } else {
                    $("#managerEmail").addClass("error");
                }
            } else {
                $("#managerName").addClass("error");
            }
        } else {
            var params = { isManager: true, managerName: '', managerEmail: '' };
            IREP.callApi("fivestar/managerinfo", "POST", params).done(function () {
            });
            showTY();
        }
    };

    var showTY = function () {
        $(".registration, #managerInfo, #managerSubmit").hide();
        $("#submitThanks").show();
    }

    return {
        init:init
    };
})();

